import { render, staticRenderFns } from "./givenList.vue?vue&type=template&id=3dbe9d01&scoped=true&"
import script from "./givenList.vue?vue&type=script&lang=js&"
export * from "./givenList.vue?vue&type=script&lang=js&"
import style0 from "./givenList.vue?vue&type=style&index=0&id=3dbe9d01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe9d01",
  null
  
)

export default component.exports